import React from 'react';

const Footer = () => {
    return (
        <div className="app-wrapper-footer fixed-foote">
            <div className="app-footer">
                <div className="app-footer__inner" style={{backgroundColor:'#FFF'}}>
                    <div className="app-footer-left">
                       
                    </div>
                    <div className="app-footer-right">
                        <ul className="header-megamenu nav">
                            <li className="nav-item">
                                    YEXP 2025                            
                                {/* Add popover content here */}
                            </li>
                            {/* Add other navigation items here */}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;
